<template>
  <Toast
    position="bottom-center"
    group="network"
    :pt="{
      root: {
        style: {
          width: '300px'
        }
      }
    }"
  >
    <template #container="{ message, closeCallback }">
      <section class="flex flex-row p-4 gap-6 bg-black/60 rounded-xl">
        <i class="pi pi-wifi text-white text-2xl"></i>
        <div class="flex flex-col gap-2">
          <div class="flex items-center gap-5">
            <span class="font-bold text-base text-white">{{ message.summary }}</span>
          </div>
          <div class="text-white">
            <span>{{ message.detail }}</span>
          </div>
          <div class="flex gap-4">
            <Button :label="$t('refresh')" size="small" @click="refreshPage"></Button>
          </div>
        </div>
        <div class="flex h-6">
          <Button
            :pt="{
              icon: {
                style: {
                  color: 'white'
                }
              }
            }"
            variant="text"
            icon="pi pi-times"
            size="small"
            class="text-white"
            @click="close(closeCallback)"
          />
        </div>
      </section>
    </template>
  </Toast>
</template>

<script lang="ts" setup>
const emits = defineEmits(['close']);

function close(callback: CallableFunction) {
  emits('close');
  callback();
}
function refreshPage() {
  window.location.reload();
}
</script>
